<!-- ai 案例 -->
<template>
  <div class="case">
    <h4 class="current">您的位置：<router-link to="/home">首页 </router-link> &gt;资讯中心</h4>
    <div class="article">
      <h5>医疗控费难，难在何处？</h5>
      <h6>2019-03-16 &nbsp;&nbsp;&nbsp;&nbsp; 来源：医学界智库</h6>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近年来医疗机构迎来了前所未有的发展机遇，诊疗服务能力、发展规模和现实效益得到了显著提升。然而医疗费用过快增长，即加重患者负担，也在一定程度上加大医保资金风险压力。
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        基于此，国家加大了对医疗控费工作的管理力度，通过“保质量、挤水份”的措施，控制不合理医疗费用增长。然而如何保障政府医保政策的健康实施、医疗机构的可持续发展，是管理者必须思索和研究的问题。
      </p>
      <p>
        <br />
        <span class="boldblack font18">导致医疗费用过快增长的原因有哪些？</span> <br />
        <br /><span class="boldred">（一）政府财政投入供给不对称。</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随着社会发展，政府对医疗机构投入逐年加大，然而伴随民众美好健康生活的需求提升、医疗成本支出的逐年加大，取消药品加成、医保控费、公立医院养老保险参保等政策的实施，政府投入与医疗服务需求仍存在供给不对称。
        加之受财政对医疗机构长效投入机制不完善、地方财政财力薄弱、配套保障政策难落实及财政长期债务化解支持政策不明朗等因素影响，迫使医疗机构必须通过市场筹资来维持自身的运行发展，致使医疗费用过快增长。

        <br />

        <br /><span class="boldred">（二）医保管理模式亟待完善。</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;医疗保险机构筹措经费有限，主要通过定额缴费、政府定额补助的方式筹资，受整体统筹层次不高，基金抵抗风险能力较弱，不同医保基金运行管理政策不一，各地政府财政补助力度不同，致使基金收支不平衡、风险控制能力弱等问题日益凸显。

        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;医保管理部门“以收定支，量入为出，略有结余”的定额管理模式（每月对医保基金限额予以兑现，医疗机构诊疗超支部分医保经费不予拨付，未达到限额标准的据实进行结算）有时会受气候环境、流行病学等因素影响，病人就诊率存在高、低峰，致使医疗机构每年都有垫付医疗费用不能全额收回，变向导致医疗机构通过提高医疗费用来增加收入。

        <br /><br /><span class="boldred">（三）“药价虚高”问题急需解决。</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近年来，国家采取了一系列措施来降低药品价格，然而药价虚高的问题依然存在。究其原因有以下几点：

        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;药品、卫材生产、流通环节多、监管难度大，部分企业钻监管漏洞，通过更换常用药品名称、包装等借机提升药价，部分垄断性药企恶性涨价，最终导致药价虚高。
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;因为长期以来医务人员技术和劳务价值价格偏低，而药品、辅检等的价格明显偏高，造成医疗服务必须通过与药品、辅检相绑架的模式来进行价值体现，在一定程度上导致“药价虚高”问题的产生。
        <br />

        <br /><span class="boldred">（四）医疗机构管理漏洞有待填补。</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市场机制下患者诊疗服务需求的提升、政府投入的不足和医疗机构间的竞争给医院发展带来巨大压力，医院为谋求生存发展，公益性淡化而趋利性增加的问题日益凸显，在一定程度上导致医疗费用的增长。随着医疗纠纷的增加，部分医务人员为有效规避医疗风险，存在为病人选择大而全的检查、选择特效药、高价药的现象，进一步加大医疗费用支出的同时，增加了医保资金的负担。

        <br /><br /><span class="boldblack font18">如何缓解医保资金风险压力？</span> <br />

        <br /><span class="boldred">（一）充分发挥政府职能作用。</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;加快构筑财政对医院投入动态长效机制，厘清和调整好中央与地方财政事权和支出责任，加大对地方财政薄弱地区资金扶持力度，切实履行好对医疗机构尤其是公立医疗机构的领导、保障、管理、监督职责。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;充分落实好符合区域卫生规划的医疗机构基本建设、设备购置、学科发展、人才培养及各类国家补偿机制，营造良好政策发展体系。建立科学规范的财政资金绩效考评机制，保障医保政策健康实施。
        <br />
        <br /><span class="boldred">（二）加快完善医保制度管理体系。</span
        ><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;加快完善医保制度设计，制定科学合理筹措资金机制，建立不同人群医保缴费弹性机制，提高统筹水平，保障医保资金的稳定性和公平性。
        健全完善医保制度监督保障机制，应用行政监管、民众监管、医疗机构自管三维一体的管理模式，提高基金运行效率，保证基金支出合理增长、健康可持续。稳步探索医保资金保值增值办法，进一步提升资金应用的安全性。
        坚持“试点推进、动态调整、创新发展”模式，有效整各类医保资源，最终实现医保资源合理配置、合理应用、全民皆保的目标。

        <br /><br /><span class="boldred">（三）着力解决“药价虚高”问题。</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;打破部分药企垄断格局，鼓励社会资本、国外资本进入药品生产领域，采取竞争方式破解恶性涨价问题。
        采取公开、透明方式，对药品生产、流通成本及销售流程进行公示，引入信息化手段、发动民众监管来不断提升管理效率，有效解决“药价虚高”问题。
        加快完善医疗服务价格管控机制，充分体现医务人员诊疗技术和劳务价值，如通过调整或增加挂号费、专家费、护理费、治疗费、药事服务费等方式，保障医生合理的劳动收益，进而解除诊疗服务与药品、辅检绑架问题。

        <br /><br /><span class="boldred">（四）着力弥补医疗机构管理漏洞。</span
        ><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;加快转变医疗机构思维模式、调整发展方向，通过“强化预算管理，加强成本控制，调整收入结构”，来实现有效控费、健康运转的目标。
        加大对干部职工控费工作政策宣传力度，让其准确明白控费重要性和紧迫性。以医疗机构近几年业务发展情况为参考依据，加强各科室成本控制，准确核定各科室控费指标，重点对例均费用、药占比、耗占比及平均住院日等硬性指标进行管控。
        制定严谨科学的考核办法，重点对合理检查、合理治疗、合理收费问题进行监管，将监管内容纳入绩效考核和医务人员医德医风档案，严格奖惩，兑现措施到科室和个人。
        医疗控费是一项艰巨、长期而又复杂的任务，它的最终目的就是要保障政府医保惠民政策健康实施、医疗机构健康可持续发展和患者就医获得感得到提升。管理者必须要深刻认识，以坚定的毅力，超强的信心，积极投入到医保控费的工作中来，着力撑好民众健康的保护伞。
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
